import '../paedml-modal.tag'
import '../paedml-form-input.tag'

<paedml-modal-regenerate-apitoken>
  <paedml-modal prefix={opts.prefix} heading={opts.heading} opname={opts.opname} submitfunc={submitHandler}>
  
    <yield to="fields">
    <div class="row" if={!parent.data.initialized}>
          <div class="col-md-12">
            <div class="mt-2 mr-1 p-2 border border-danger">
              <span><paedml-icon icon="fas-exclamation-triangle" simple="danger" />
                  <strong class="text-danger pl-1 pt-2">Der MDM-Server ist noch nicht gestartet oder vollständig konfiguriert. Der API-Token kann nicht neu erstellt werden.</strong>
              </span>
              </div>
          </div>
      </div>
      <div class="row" if={parent.data.initialized}>
        <div class="col-md-12">
          <p>Der API-Token für die Verbindung zu dem MDM System wird neu erstellt.</p>
        </div>
      </div>
      <div class="row" if={parent.data.initialized}>
          <div class="col-md-12">
          <div class="mt-2 mr-1 p-2 border border-info">
              <span><paedml-icon icon="fas-info-circle" simple="info" />
                  <strong class="text-info pl-1 pt-2">Die Erstellung des API-Tokens kann einige Minuten dauern.</strong>
              </span>
              </div>
          <div class="p-2"></div>
          </div>
      </div>
    </yield>
  </paedml-modal>
    
    <script>
      import { handleSubmitCreateOrEdit } from '../../util/api-util'
      
      this.opname = this.opts.opname
      this.data = {}
      this.edit = true
      this.api = this.opts.api
      this.patient = opts.patient

      this.data = {
        initialized: false
      }

      this.on('dataRequested', (e) => {
        let status = e.data()[0][8]
        this.data.initialized = status === 5
      })

      this.submitHandler = formData => {
      
      return this.api.apitoken().then(rsp => {

        if(!this.data.initialized){
          return Promise.resolve('Operation abgebrochen')
        }

        const [data, status] = rsp
        if (status.error) return Promise.reject('Kommunikationsfehler mit dem Server')

        if(status.success){
          this.parent.trigger('reloadTable')
          return 'Der Job zur Erstellung des API-Tokens wurde erfolgreich gestartet.'
        }
      })
    }
    </script>
</paedml-modal-regenerate-apitoken>
